import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { RadioGroup } from 'react-form';

import { getAllowedEventTypes } from '../../../../utils/events';
import { required } from '../../../../utils/form-validation';
import Tip from '../../../Tip';
import {
    RadioButton,
} from '../../../Form';
import links from '../../../../../config/links';
import { sportTypeIds } from '../../../../utils/eventConstants';

function SelectEventType(props) {
    const {
        field,
        value,
        formApi,
        onChange,
        editing,
        isTemplate,
        club,
        coreUI,
        sportTypeId,
    } = props;

    const { values } = formApi;

    const [eventTypeOptions, setEventTypeOptions] = useState([]);

    useEffect(() => {
        setEventTypeOptions(isTemplate ? coreUI.types.tms.eventTypes : getAllowedEventTypes({
            club: club.clubDetails,
            hsEventType: values.hsEventType,
            sportTypeId,
        }));

        return function cleanup() {
            setEventTypeOptions([]);
        };
    // }, [formApi]);
    }, []);

    return (
        <div className={`col-12`}>
            <div className="row">
                <div className="col-12">
                    <label className="mb8">
                    What type of event are you creating?
                    </label>
                    <Tip
                        variant="info"
                        valign="top"
                        showTip={!isTemplate && eventTypeOptions && eventTypeOptions.length !== 1}
                        dangerouslySetInnerHTML={true}
                        content={`Choose the type that best fits your event. After registration, you can place players into any draw format you would like. <a href="${sportTypeId === sportTypeIds.PICKLEBALL ? links.pickleballSportTypeArticle : links.tennisSportTypeArticle}" target="_blank">Learn More</a>`}
                    >
                        {eventTypeOptions && eventTypeOptions.length > 0 && (
                            <RadioGroup
                                key={eventTypeOptions.map((o) => { return o.id; }).join('')}
                                field={field}
                                value={value}
                                validate={required}
                                onChange={onChange}
                            >
                                {eventTypeOptions && eventTypeOptions.map((option) => {
                                    return (
                                        <RadioButton
                                            key={`eventType-${option.value}`}
                                            label={option.label}
                                            description={option.description}
                                            value={option.id}
                                            id={`eventType-${option.value}`}
                                            disabled={editing}
                                        />
                                    );
                                })}
                            </RadioGroup>
                        )}
                    </Tip>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps({ club, coreUI }) {
    return { club, coreUI };
}

export default connect(mapStateToProps)(SelectEventType);
